// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__vPa7O","h1":"Hero_h1__NOE0P","p":"Hero_p__Dsti9","orange":"Hero_orange__HvQah","underline":"Hero_underline__7OumM","button":"Hero_button__UFpto"};